import Parallax from "parallax-js";

export const initParallax = {
  init(){
    const parallaxScene = document.getElementById('parallax-scene');
    if (!parallaxScene) return; // 要素が存在しない場合は処理を終了
    const parallaxInstance = new Parallax(parallaxScene,{
      relativeInput: false,
      originX: 0.5,
      originY: 0.5,
      calibrateX: false,
      calibrateY: false,
      invertX:false,
      invertY:true,
      scalarY:2,
    });
    console.log(`initParallax.js loaded!`);


  }
}